
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { EventForm } from './EventForm';
import { Edit } from 'lucide-react';

interface EditEventModalProps {
  event: any;
  children?: React.ReactNode;
}

export const EditEventModal: React.FC<EditEventModalProps> = ({ event, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSuccess = () => {
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div onClick={() => setIsOpen(true)}>
        {children || (
          <Button className="bg-purple-600 hover:bg-purple-700 text-white flex items-center gap-2">
            <Edit className="h-4 w-4" />
            Edit Event
          </Button>
        )}
      </div>

      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-2xl font-bold text-gray-900">Edit Event</DialogTitle>
          </DialogHeader>
          
          <EventForm 
            event={event}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
